var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-ons-page",
    [
      _c("v-ons-toolbar", { attrs: { modifier: "transparent" } }),
      _vm._v(" "),
      _c("div", { staticClass: "page__background page--material__background" }),
      _vm._v(" "),
      _c("div", { staticClass: "header" }, [
        _c("div", { staticClass: "logo-menu" }, [
          _c("img", {
            attrs: { src: require("../assets/logo-ifacare-white.png") }
          })
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "close-menu" },
          [_c("v-ons-icon", { attrs: { icon: "fa-times" } })],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "custom-sidebar" }, [
        _vm.profileArr.member_membership == "vvip"
          ? _c(
              "div",
              { staticClass: "sidebar-vvip" },
              [
                _c(
                  "v-ons-lis",
                  [
                    _vm._l(_vm.getListMenu, function(menuArr, index) {
                      return _c(
                        "v-ons-list-item",
                        {
                          key: index,
                          on: {
                            click: function($event) {
                              return _vm.goTo("" + menuArr.name)
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "left" },
                            [
                              _c("v-ons-icon", {
                                attrs: {
                                  "fixed-width": "",
                                  icon: menuArr.meta.icon
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "center" }, [
                            _vm._v(_vm._s(menuArr.meta.title))
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "right" },
                            [
                              _c("v-ons-icon", {
                                attrs: {
                                  "fixed-width": "",
                                  icon: menuArr.meta.icon1
                                }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _vm.$store.state.user.token
                      ? _c("v-ons-list-item", { on: { click: _vm.logout } }, [
                          _c(
                            "div",
                            { staticClass: "left" },
                            [
                              _c("v-ons-icon", {
                                attrs: {
                                  "fixed-width": "",
                                  icon: "sign-out-alt"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "center" }, [
                            _vm._v("Logout")
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("v-ons-list-header", [_vm._v("SLA")]),
                    _vm._v(" "),
                    _vm._l(_vm.essentialLinks, function(item) {
                      return _c(
                        "v-ons-list-item",
                        {
                          key: item.link,
                          on: {
                            click: function($event) {
                              return _vm.goToExternal(item.link)
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "left" },
                            [
                              _c("v-ons-icon", {
                                attrs: { "fixed-width": "", icon: item.icon }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "center" }, [
                            _vm._v(_vm._s(item.label))
                          ])
                        ]
                      )
                    })
                  ],
                  2
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.profileArr.member_membership == "premium"
          ? _c(
              "div",
              { staticClass: "sidebar-premium" },
              [
                _c(
                  "v-ons-lis",
                  [
                    _vm._l(_vm.getListMenu, function(menuArr, index) {
                      return _c(
                        "v-ons-list-item",
                        {
                          key: index,
                          on: {
                            click: function($event) {
                              return _vm.goTo("" + menuArr.name)
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "left" },
                            [
                              _c("v-ons-icon", {
                                attrs: {
                                  "fixed-width": "",
                                  icon: menuArr.meta.icon
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "center" }, [
                            _vm._v(_vm._s(menuArr.meta.title))
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "right" },
                            [
                              _c("v-ons-icon", {
                                attrs: {
                                  "fixed-width": "",
                                  icon: menuArr.meta.icon1
                                }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _vm.$store.state.user.token
                      ? _c("v-ons-list-item", { on: { click: _vm.logout } }, [
                          _c(
                            "div",
                            { staticClass: "left" },
                            [
                              _c("v-ons-icon", {
                                attrs: {
                                  "fixed-width": "",
                                  icon: "sign-out-alt"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "center" }, [
                            _vm._v("Logout")
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("v-ons-list-header", [_vm._v("SLA")]),
                    _vm._v(" "),
                    _vm._l(_vm.essentialLinks, function(item) {
                      return _c(
                        "v-ons-list-item",
                        {
                          key: item.link,
                          on: {
                            click: function($event) {
                              return _vm.goToExternal(item.link)
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "left" },
                            [
                              _c("v-ons-icon", {
                                attrs: { "fixed-width": "", icon: item.icon }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "center" }, [
                            _vm._v(_vm._s(item.label))
                          ])
                        ]
                      )
                    })
                  ],
                  2
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.profileArr.member_membership == "umum"
          ? _c(
              "div",
              { staticClass: "sidebar-free" },
              [
                _c(
                  "v-ons-lis",
                  [
                    _vm._l(_vm.getListMenu, function(menuArr, index) {
                      return _c(
                        "v-ons-list-item",
                        {
                          key: index,
                          on: {
                            click: function($event) {
                              return _vm.goTo("" + menuArr.name)
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "left" },
                            [
                              _c("v-ons-icon", {
                                attrs: {
                                  "fixed-width": "",
                                  icon: menuArr.meta.icon
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "center" }, [
                            _vm._v(_vm._s(menuArr.meta.title))
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "right" },
                            [
                              _c("v-ons-icon", {
                                attrs: {
                                  "fixed-width": "",
                                  icon: menuArr.meta.icon1
                                }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _vm.$store.state.user.token
                      ? _c("v-ons-list-item", { on: { click: _vm.logout } }, [
                          _c(
                            "div",
                            { staticClass: "left" },
                            [
                              _c("v-ons-icon", {
                                attrs: {
                                  "fixed-width": "",
                                  icon: "sign-out-alt"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "center" }, [
                            _vm._v("Logout")
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("v-ons-list-header", [_vm._v("SLA")])
                  ],
                  2
                )
              ],
              1
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.profileArr.member_type == "pasien"
        ? _c("div", { staticClass: "custom-sidebar" }, [
            _c(
              "div",
              { staticClass: "default-sidebar" },
              [
                _c(
                  "v-ons-list",
                  [
                    _vm._l(_vm.getListMenu, function(menuArr, index) {
                      return _c(
                        "v-ons-list-item",
                        {
                          key: index,
                          on: {
                            click: function($event) {
                              return _vm.goTo("" + menuArr.name)
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "left" },
                            [
                              _c("v-ons-icon", {
                                attrs: {
                                  "fixed-width": "",
                                  icon: menuArr.meta.icon
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "center" }, [
                            _vm._v(_vm._s(menuArr.meta.title))
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "right" },
                            [
                              _c("v-ons-icon", {
                                attrs: {
                                  "fixed-width": "",
                                  icon: menuArr.meta.icon1
                                }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _vm.$store.state.user.token
                      ? _c("v-ons-list-item", { on: { click: _vm.logout } }, [
                          _c(
                            "div",
                            { staticClass: "left" },
                            [
                              _c("v-ons-icon", {
                                attrs: {
                                  "fixed-width": "",
                                  icon: "sign-out-alt"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "center" }, [
                            _vm._v("Logout")
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("v-ons-list-header", [_vm._v("SLA")]),
                    _vm._v(" "),
                    _vm._l(_vm.essentialLinks, function(item) {
                      return _c(
                        "v-ons-list-item",
                        {
                          key: item.link,
                          on: {
                            click: function($event) {
                              return _vm.goToExternal(item.link)
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "left" },
                            [
                              _c("v-ons-icon", {
                                attrs: { "fixed-width": "", icon: item.icon }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "center" }, [
                            _vm._v(_vm._s(item.label))
                          ])
                        ]
                      )
                    })
                  ],
                  2
                )
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-ons-list",
        [
          _c("v-ons-list-item", [
            _c("div", { staticStyle: { margin: "5px", "font-size": "12px" } }, [
              _c("p", { staticClass: "m-b-0 m-t-0" }, [
                _vm._v(_vm._s(_vm.APP_NAME))
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "m-t-0" }, [
                _vm._v(_vm._s(_vm.APP_VERSION))
              ])
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1e984dbe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e984dbe","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MenuPage.vue
// module id = null
// module chunks = 